import React, { useState } from "react";
import SelectBox from "../Form/SelectBox";
import { withApi, apiShape, withNotifier, notifierShape } from "../../context";

type Props = {
  api?: apiShape;
  notifier?: notifierShape;
  assetId?: number;
};

export function AssetStatusSelect(props: Props) {
  const [assetStatuses, setAssetStatuses] = useState();
  const [fetching, setFetching] = useState();
  const { api, notifier, assetId } = props;

  const loadAssetStatuses = async () => {
    try {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'true' is not assignable to param... Remove this comment to see the full error message
      setFetching(true);
      const endpoint = assetId
        ? `/assets/${assetId}/status-options`
        : "/asset/statuses";

      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      const response = await api.get(endpoint, { include: "tenant" });
      setAssetStatuses(
        response.asset_statuses.map((assetStatus: $TSFixMe) => ({
          id: assetStatus.id,
          name: assetStatus.name,
          tenantId: assetStatus?.tenant?.id,
          tenantPublic: assetStatus?.tenant?.public,
          tenantName: assetStatus?.tenant?.name,
        })),
      );
    } catch (error) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      notifier.showError(api.translateError(error));
    } finally {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'false' is not assignable to para... Remove this comment to see the full error message
      setFetching(false);
    }
  };

  React.useEffect(() => {
    loadAssetStatuses();
  }, [assetId]);

  // @ts-expect-error TS(2322) FIXME: Type '{ options: undefined; fetching: undefined; a... Remove this comment to see the full error message
  return <SelectBox {...props} options={assetStatuses} fetching={fetching} />;
}

export default withNotifier(withApi(AssetStatusSelect));
